module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<a href="#" class="header-wrap" data-toggle="expand-spoiler"><header><h5 data-text="context-header" class="module-title">'+
((__t=( i18n.tc( "ControlNotifications", "Notifications" ) ))==null?'':__t)+
'</h5><i class="icon icon-material icon-expand"></i></header></a><div class="notifications-wrap" data-region="notifications"></div><div class="expand-spoiler';
 if ( isOpen ) { 
__p+=' open';
 } 
__p+='" data-container="expand-spoiler"><div class="expand-content"><div data-region="container"></div></div></div>';
}
return __p;
};
